import React from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import humanize from 'humanize-string';
import {Tooltip, Typography} from '@material-ui/core';
import {Slideshow, VideoLibrary, Movie, Devices} from '@material-ui/icons';
import {baseRoutes} from 'App/AppRouter/routes';
import {WFState} from 'MediaOrders/MediaOrdersTypes';
import {
    Statuses,
    IconTypes,
    ContentItem,
    RenderTitle,
    IconTypesKeys,
} from './SearchTypes';
import {getUUID} from './SearchHandlers';

export const renderSearchItemLink = ({
    contentItemType,
}: {
    contentItemType: IconTypesKeys;
}) => <SearchItemIcons type={contentItemType} />;

export const SearchItemIcons = ({type}: {type: IconTypesKeys}) => {
    switch (type) {
        case IconTypes.film:
            return <Movie className="film" />;
        case IconTypes.series:
            return <VideoLibrary className="series" />;
        case IconTypes.webOriginal:
            return <Devices className="web-original" />;
        default:
            return <Slideshow className="episode" />;
    }
};

export const renderTitle = (query = '') => ({
    displayTitle,
    contentItemType,
    id,
    mamId,
}: RenderTitle) => (
    <Tooltip title={humanize(contentItemType)} enterDelay={800} enterNextDelay={300}>
        <div className="search-table-item-name">
            <Link to={`${baseRoutes.contentItems}/${id}`}>
                {getHighlighted(displayTitle, query)}
            </Link>
            <div className="uuid">{getHighlighted(getUUID(mamId), query)}</div>
        </div>
    </Tooltip>
);

const getHighlighted = (text = '', highlight = '') => {
    if (!highlight.trim()) return text;

    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

    return (
        <>
            {parts.map((part: string, i: number) => (
                <span
                    key={i}
                    className={
                        part.toLowerCase() === highlight.toLowerCase()
                            ? 'font-extra-bold'
                            : 'font-light'
                    }
                >
                    {part}
                </span>
            ))}
        </>
    );
};

const getClass = (state: string) => {
    switch (state) {
        case WFState.DELIVERY_PENDING:
            return 'status-orange';

        case WFState.QC_FAILED:
        case WFState.DELIVERY_FAILED:
            return 'status-red';

        case WFState.DELIVERY_CANCELLED:
            return 'status-grey';

        default:
            return 'status-white';
    }
};

export const renderStatus = (statuses: Statuses) => ({
    workflowState,
    createdAt,
}: ContentItem) => {
    const classes = classNames(
        'search-table-item-name',
        'right',
        getClass(workflowState)
    );

    return (
        <Typography className={classes}>
            <span>{statuses[workflowState]}</span>
            <span className="date">{createdAt}</span>
        </Typography>
    );
};

const searchTableColumns = (query: string, statuses: Statuses = {}) => [
    {
        dataKey: '',
        title: '',
        render: renderSearchItemLink,
    },
    {
        dataKey: 'displayTitle',
        title: 'Series/Title',
        render: renderTitle(query),
    },
    {
        dataKey: 'contentPartnerName',
        title: 'Content Partner',
    },
    {
        dataKey: 'workflowState',
        title: 'Workflow state',
        render: renderStatus(statuses),
    },
];

export default searchTableColumns;
